<template>
  <HScaffold :title="isModify?'修改地址':'添加地址'">
    <van-address-edit
        :area-list="areaList"
        show-set-default
        :area-columns-placeholder="['请选择','请选择','请选择']"
        @save="onSave"
        :address-info="addressInfo"
    />
  </HScaffold>

</template>


<script setup>
  import HScaffold from "@/components/utils/HScaffold.vue";
  import {areaList} from '@vant/area-data';
  import {useUserStore} from "@/stores/useUser.js";
  import {useHHttp} from "@/hooks/useHHttp.js";
  import {hr} from "@/components/utils/HRouter.js";

  let useUser = useUserStore();
  let useHttp = useHHttp();
  const getParams = hr.getRouteParams();
  const addressInfo = ref({});
  let isModify = ref(getParams["isModify"] ?? false);
  if ("data" in getParams) {
    let tData = getParams["data"];
    let tempArray = tData["City"].split('-');
    addressInfo.value = {
      name: tData["Name"],
      tel: tData["Mobile"],
      province: tempArray.length > 1 ? tempArray[0] : "",
      city: tempArray.length > 2 ? tempArray[1] : "",
      county: tempArray.length > 2 ? tempArray[2] : "",
      addressDetail: tData["Address"],
      areaCode: "",
      isDefault: tData["Default"] === 1,
    };
  }
  const onSave = (info) => {
    useHttp.request(
        isModify.value
            ? "/app/profile/modify-delivery"
            : "/app/profile/add-delivery",
        (data) => {
          data["Data"].sort((a, b) => b["Default"] - a["Default"]);
          useUser.addressList = data["Data"];
          hr.goBack();
        }, {
          params: {
            "Id": isModify.value ? getParams["data"]["Id"] : "",
            "UserId": useUser.userId,
            "Name": info.name,
            "Mobile": info.tel,
            "City": info.province + " - " + info.city + '-' + info.county,
            "Address": info.addressDetail,
            "Default": useUser.addressList.length <= 0 ? 1 : (info.isDefault ? 1 : 0),
          }
        });
  };
</script>


<style scoped>
</style>
